@if (isAuthenticated$ | async) {
  <ul class="navbar-nav">
    <li class="nav-item d-none" [class.d-xxl-block]="!isScannerApp() && authService.showSettings">
      <a class="nav-link text-white" routerLink="/Settings/ApplicationSetting">
        <i class="fa fa-cog"></i>
      </a>
    </li>
    <li class="nav-item">
      <a class="nav-link text-white text-nowrap" target="_blank" [routerLink]="ApplicationPaths.ProfilePathComponents">
        {{ userName$ | async }}
      </a>
    </li>
    <li class="nav-item">
      <a
        class="nav-link text-white text-nowrap"
        [routerLink]="ApplicationPaths.LogOutPathComponents"
        [state]="{ local: true }"
      >
        {{ translateMenu('Log out') }}
      </a>
    </li>
  </ul>
}
@if ((isAuthenticated$ | async) === false) {
  <ul class="navbar-nav">
    <li class="nav-item">
      <a class="nav-link text-white text-nowrap" [routerLink]="ApplicationPaths.LoginPathComponents">
        {{ translateMenu('Log in') }}
      </a>
    </li>
  </ul>
}
